import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        Within the curtilage of the Grade II listed Farm House, a simple
        red-brick store building is proposed to be to become a series of
        holiday-lets. The separate volumes are well-proportioned, with hand-cut
        oak roof trusses sitting proudly in the centre of each roof space.
      </p>
      <p>
        The proposals are to carefully insert bedrooms, kitchens, and bathrooms
        into each space as self-contained ‘pods’, expressed as separate and new
        against the existing exposed materials. The living area will be within
        the remaining volume, with an additional bed-space above for extra
        sleeping space, or simply for those who like to sleep amongst the
        rafters.
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/hall-farm-holiday-lets.jsx